import { onCleanup } from 'solid-js'

export type StickyCallback = (isStuck: boolean) => void

export const sticky = (el: HTMLElement, accessor: () => StickyCallback): void => {
  const callback = accessor()

  // Create sentinel element placed in normal flow right before the sticky element
  const sentinel = document.createElement('div')
  sentinel.style.height = '1px'
  sentinel.style.width = '100%'
  sentinel.style.marginBottom = '-1px'
  sentinel.style.pointerEvents = 'none'
  sentinel.setAttribute('aria-hidden', 'true')

  const parent = el.parentElement
  if (!parent) return

  // Insert sentinel before the sticky element
  parent.insertBefore(sentinel, el)

  let isInitialized = false
  let lastIsStuck: boolean | null = null

  const observer = new IntersectionObserver(
    ([entry]) => {
      const isStuck = !entry.isIntersecting

      // Skip the initial callback on page load (fires synchronously when observer starts)
      if (!isInitialized) {
        isInitialized = true
        // Don't set lastIsStuck here - let the first real scroll trigger the callback
        return
      }

      // Only call callback if state actually changed
      if (lastIsStuck !== isStuck) {
        lastIsStuck = isStuck
        callback(isStuck)
      }
    },
    { threshold: 0 }
  )

  observer.observe(sentinel)

  onCleanup(() => {
    observer.disconnect()
    sentinel.remove()
  })
}
